<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo mt-0 mb-0">
      <img
        :src="style.loginImage"
        width="150px"
      >
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h3 class="mb-1">
          Caixa Fora de Operação ⏸️
        </h3>
        <p class="mb-3">
          Este terminal está inativo no momento. Tente atualizar a página e se o erro persistir,
          entre em contato com o suporte.
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          @click="refresh"
        >Atualizar página</b-button>

        <b-button
          variant="danger"
          class="ml-1 mb-1 btn-sm-block"
          @click="logout"
        >
          Sair
        </b-button>

        <b-img
          fluid
          :src="imgUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import store from '@/store/index'
import { app, payboxConfiguration } from '@/mixins'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BLink,
    BImg,
    BButton,
  },
  mixins: [app, payboxConfiguration],
  data() {
    return {
      downImg: require('@/assets/images/pages/pay-box-inactive.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/pay-box-inactive-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    refresh() {
      this.mxPdvRouteRedirect()
    },

    logout() {
      useJwt.logout()
      this.refresh()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
